import React from 'react'
import CardNew from 'presentation/shared/components/CardNew'

interface AverageTimeCardProps {
  averageTime: number
  type: 'authorization' | 'conclusion'
}

export const AverageTimeCard = ({
  averageTime,
  type
}: AverageTimeCardProps) => {
  const titles = {
    authorization: {
      header: 'Tempo médio de autorização',
      start: 'CRIAÇÃO DO PEDIDO',
      end: 'AUTORIZAÇÃO DO PEDIDO',
      description:
        'Este é o tempo médio gasto para a autorização dos seus pedidos cirúrgicos desde o momento da criação do pedido.'
    },
    conclusion: {
      header: 'Tempo médio de realização',
      start: 'CRIAÇÃO DO PEDIDO',
      end: 'REALIZAÇÃO DO PEDIDO',
      description:
        'Este é o tempo médio gasto para a realização das suas cirurgias desde o momento da criação do pedido cirúrgico, contemplando o tempo de autorização.'
    }
  }

  const { header, start, end, description } = titles[type]

  return (
    <CardNew
      background="neutral25"
      style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: '16px',
        padding: '24px',
        textAlign: 'center',
        width: '100%',
        borderRadius: '12px',
        boxShadow: '0px 2px 4px rgba(0, 0, 0, 0.1)'
      }}
    >
      <h1
        style={{
          fontSize: '14px',
          fontWeight: 600,
          color: '#4A4A4A',
          margin: 0
        }}
      >
        {header}
      </h1>
      <p
        style={{
          fontSize: '32px',
          fontWeight: 700,
          color: '#622992',
          margin: 0
        }}
      >
        {averageTime} dias
      </p>
      {/* Timeline */}
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          width: '90%',
          gap: '8px',
          marginTop: '16px',
          position: 'relative'
        }}
      >
        {/* Line */}
        <div
          style={{
            flexGrow: 1,
            height: '2px',
            background: '#CC91FF',
            position: 'relative'
          }}
        >
          <div
            style={{
              position: 'absolute',
              left: 0,
              top: '-5px',
              width: '12px',
              height: '12px',
              borderRadius: '50%',
              background: '#CC91FF'
            }}
          />
          <div
            style={{
              position: 'absolute',
              right: 0,
              top: '-5px',
              width: '12px',
              height: '12px',
              borderRadius: '50%',
              background: '#CC91FF'
            }}
          />
        </div>
      </div>
      {/* Labels */}
      <div
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          width: '100%',
          marginTop: '8px'
        }}
      >
        <span style={{ fontSize: '12px', fontWeight: 500, color: '#4A4A4A' }}>
          {start}
        </span>
        <span style={{ fontSize: '12px', fontWeight: 500, color: '#4A4A4A' }}>
          {end}
        </span>
      </div>
      <p
        style={{
          fontSize: '12px',
          fontWeight: 400,
          color: '#4A4A4A',
          lineHeight: '20px',
          margin: '16px 0 0'
        }}
      >
        {description}
      </p>
    </CardNew>
  )
}
